document.addEventListener('DOMContentLoaded', () => {
    const sound = document.getElementById('sonidoLadrido');

    if (sound) {
        window.reproducirSonido = function () {
            sound.currentTime = 0;
            sound.play();
        };
    }

    const menuButton = document.querySelector(
        'button[aria-controls="MenuPrincipal"]'
    );
    const menu = document.getElementById('MenuPrincipal');

    if (menuButton && menu) {
        menuButton.addEventListener('click', () => {
        const isOpen = menuButton.getAttribute('aria-expanded') === 'true';

        menuButton.setAttribute(
            'aria-expanded',
            String(!isOpen)
        );
        menu.classList.toggle('Abierto', !isOpen);
        });
    }

    const menuItems = document.querySelectorAll(
        '.Menu > ul > li > button'
    );

    if (menuItems.length) {
        menuItems.forEach(button => {
            button.addEventListener('click', () => {
                const li = button.closest('li');
                if (!li) return;

                const isOpen = li.classList.contains('Abierto');

                document
                .querySelectorAll('.Menu > ul > li.Abierto')
                .forEach(item =>
                    item.classList.remove('Abierto')
                );

                if (!isOpen) {
                    li.classList.add('Abierto');
                }
            });
        });
    }
});